/*
 * Chanche: no pre-selected size.
 * Fabric checks the size of the first available variant on load, so "Aggiungi al carrello"
 * works before the shopper has picked a size. Here the size radios start empty and the add-to-cart
 * buttons (main, sticky bar, quick-add) read "Seleziona una taglia" and move focus to the sizes
 * until one is chosen. Colour stays pre-selected. A product URL with ?variant= counts as a choice.
 *
 * Scope = the product section or the quick-add dialog. State lives on the scope element
 * (data-size-chosen) so it survives Fabric's morph re-renders; a MutationObserver re-applies
 * the gate after each re-render (a colour change re-checks the default size server-side).
 */
(() => {
  const SIZE_OPTION = /^(taglia|size)$/i;
  const LABEL = 'Seleziona una taglia';
  const BUTTONS = '[ref="addToCartButton"]';

  const scopeOf = (el) => el.closest('dialog') || el.closest('.shopify-section');

  const sizeInputs = (scope) =>
    Array.from(scope.querySelectorAll('variant-picker fieldset input[type="radio"]')).filter((input) =>
      SIZE_OPTION.test(input.dataset.optionName || '')
    );

  const labelSpan = (button) => button.querySelector('.add-to-cart-text__content > span > span, .add-to-cart-text__content > span');

  function gate(scope) {
    for (const input of sizeInputs(scope)) {
      input.checked = false;
      input.dataset.currentChecked = 'false';
    }
    for (const button of scope.querySelectorAll(BUTTONS)) {
      if (button.disabled) continue; // sold out / unavailable keeps Fabric's own state
      button.setAttribute('aria-disabled', 'true');
      button.dataset.sizeGate = 'on';
      const span = labelSpan(button);
      if (span && span.textContent.trim() !== LABEL) {
        span.dataset.originalLabel = span.textContent;
        span.textContent = LABEL;
      }
    }
  }

  function ungate(scope) {
    for (const button of scope.querySelectorAll('[data-size-gate="on"]')) {
      button.removeAttribute('aria-disabled');
      delete button.dataset.sizeGate;
      const span = labelSpan(button);
      if (span && span.dataset.originalLabel) {
        span.textContent = span.dataset.originalLabel;
        delete span.dataset.originalLabel;
      }
    }
  }

  function apply() {
    const scopes = new Set();
    for (const picker of document.querySelectorAll('variant-picker')) {
      const scope = scopeOf(picker);
      if (scope) scopes.add(scope);
    }
    for (const scope of scopes) {
      if (sizeInputs(scope).length < 2) continue;
      if (scope.dataset.sizeChosen === 'true') ungate(scope);
      else gate(scope);
    }
  }

  // Chosen when the page was opened on a specific variant (shared link, cart link).
  if (new URLSearchParams(location.search).has('variant')) {
    document.querySelectorAll('.shopify-section').forEach((section) => {
      if (section.querySelector('variant-picker')) section.dataset.sizeChosen = 'true';
    });
  }

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !SIZE_OPTION.test(input.dataset.optionName || '')) return;
    const scope = scopeOf(input);
    if (!scope) return;
    scope.dataset.sizeChosen = 'true';
    ungate(scope);
  });

  // Block the add while no size is chosen: capture phase runs before Fabric's delegated handlers.
  const block = (event) => {
    const button = event.target instanceof Element && event.target.closest('[data-size-gate="on"]');
    const form = event.type === 'submit' && event.target instanceof HTMLFormElement ? event.target : null;
    const scope = button ? scopeOf(button) : form ? scopeOf(form) : null;
    if (!scope || scope.dataset.sizeChosen === 'true' || sizeInputs(scope).length < 2) return;
    if (form && !form.querySelector('[data-size-gate="on"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const first = sizeInputs(scope).find((input) => !input.disabled) || sizeInputs(scope)[0];
    first.closest('fieldset')?.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    first.focus({ preventScroll: true });
  };
  document.addEventListener('click', block, true);
  document.addEventListener('submit', block, true);

  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      apply();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  apply();
})();
